import React from 'react'
import { Link } from 'react-router-dom'
import { url } from '../../Config/Config'
import image from "../../assets/images/bg.jpg"

function PageNotFound() {
  return (

    // <div className="pageNOtFOund" style={{ backgroundImage: `url(${image }})` }}>
  <div className="pageNOtFOund"> 

      <div>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p className="h5">Hmm, the page you were looking for doesn’t seem to exist.</p>
        <Link to={url + '/dashboard'} className='btn btn-primary mt-5'>Go Back</Link>
      </div>
    </div >

  )

}

export default PageNotFound
